// Applica il tema salvato prima che l'app si monti, per evitare il lampo di tema sbagliato.
export default defineNuxtPlugin(() => {
  useUiStore().caricaTemaSalvato();
});
